/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CountryResponse } from '../models/country-response';
import { getCountries } from '../fn/countries/get-countries';
import { GetCountries$Params } from '../fn/countries/get-countries';
import { getProvinces } from '../fn/countries/get-provinces';
import { GetProvinces$Params } from '../fn/countries/get-provinces';
import { ProvinceResponse } from '../models/province-response';

@Injectable({ providedIn: 'root' })
export class CountriesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCountries()` */
  static readonly GetCountriesPath = '/api/countries';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCountries()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCountries$Response(params?: GetCountries$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CountryResponse>>> {
    return getCountries(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCountries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCountries(params?: GetCountries$Params, context?: HttpContext): Observable<Array<CountryResponse>> {
    return this.getCountries$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CountryResponse>>): Array<CountryResponse> => r.body)
    );
  }

  /** Path part for operation `getProvinces()` */
  static readonly GetProvincesPath = '/api/countries/{countryId}/provinces';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProvinces()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProvinces$Response(params: GetProvinces$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProvinceResponse>>> {
    return getProvinces(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProvinces$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProvinces(params: GetProvinces$Params, context?: HttpContext): Observable<Array<ProvinceResponse>> {
    return this.getProvinces$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProvinceResponse>>): Array<ProvinceResponse> => r.body)
    );
  }

}
